/**
 * Helper function to detect and extract email address from user data
 * Handles cases where APIs return email in username field or vice versa
 */
export function extractEmailAndUsername(userData: any): { email: string | undefined;
	username: string | undefined } {
	const {
		email, username,
	} = userData;

	// Simple email regex to check if a string is an email
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

	// Check if email field contains a valid email
	const emailIsValid = email && typeof email === 'string' && emailRegex.test(email);

	// Check if username field contains an email
	const usernameIsEmail = username && typeof username === 'string' && emailRegex.test(username);

	// Determine the correct email and username
	let finalEmail: string | undefined;
	let finalUsername: string | undefined;

	if (emailIsValid) {
		// Email field contains valid email - use it
		finalEmail = email;
		// Use email as username for consistency (PostHog best practice)
		finalUsername = email;
	} else if (usernameIsEmail) {
		// Username contains email, email field is invalid/empty - use username as email
		finalEmail = username;
		finalUsername = username; // Keep username as is since it's the email
	} else {
		// Neither field contains valid email - use fallback behavior
		finalEmail = email || username;
		finalUsername = username;
	}

	return {
		email: finalEmail,
		username: finalUsername,
	};
}